import React, { Suspense } from "react";
import { MantineProvider } from "@mantine/core";
import { ModalsProvider } from "@mantine/modals";
import { Notifications } from "@mantine/notifications";
import "@mantine/notifications/styles.css";
import { BrowserRouter as Router } from "react-router-dom";
import { lmuTvTheme } from "./theme";
import LmuTvApp from "./LmuTvApp";
import CheckRefLink from "./CheckReflink";
import CookieModal from "./components/CookieBanner/CookieModal";
import { ConsentProvider } from "./components/CookieBanner/ConsentContext";
import { SessionProvider } from "./auth/SessionContext";
import { CartProvider } from "./components/Cart/CartContext";
import { WizardProvider } from "./components/BuyWizard/WizardContext";

// Self-contained root for the migrated LMUTV storefront. Mirrors the provider tree
// of the old standalone index.tsx, but scoped: maroon Mantine theme + LMUTV's own
// Consent/Session/Cart/Wizard providers, and its OWN Router.
//
// `basename` makes both entry points work with the LMUTV app's absolute routes:
//   • host mode (lmutv.de/.com)      → basename "/"      → "/" is the storefront
//   • path mode (…/lmutv on the hub) → basename "/lmutv" → "/lmutv" is the storefront
// index.tsx renders this INSTEAD of the hub app (top-level either/or), so there is
// never a nested <Router>.
export function LmuTvRoot({ basename }: { basename: string }) {
  return (
    <MantineProvider defaultColorScheme="dark" theme={lmuTvTheme}>
      <ConsentProvider>
        <CheckRefLink />
        <CookieModal />
        <ModalsProvider>
          <Suspense fallback={<></>}>
            <Notifications />
            <Router basename={basename}>
              <SessionProvider>
                <CartProvider>
                  <WizardProvider>
                    <LmuTvApp />
                  </WizardProvider>
                </CartProvider>
              </SessionProvider>
            </Router>
          </Suspense>
        </ModalsProvider>
      </ConsentProvider>
    </MantineProvider>
  );
}
